import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    problemName: yup.string().required('Problem name is required'),
    problemDescription: yup.string().nullable()
})
    .required();
export const AddProblemListModal = (props) => {
    const { onRequestClose, problemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            problemName: problemToEdit ? problemToEdit.problemName : '',
            problemDescription: problemToEdit ? problemToEdit.problemDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ problemName, problemDescription }) => {
        setIsSubmitting(true);
        const data = {
            problemName: problemName == '' ? null : problemName,
            problemDescription: problemDescription == '' ? null : problemDescription
        };
        console.log(data);
        if (problemToEdit) {
            const response = await axios.post('/api/carePlan/editProblemList', {
                problemId: problemToEdit.id,
                problemName: data.problemName,
                problemDescription: data.problemDescription
            });
            const new_problem = response.data.data.new_problem_list;
            const updatedProblem = {
                id: new_problem.id,
                patientId: new_problem.patient_id,
                carePlanId: new_problem.care_plan_id,
                problemName: new_problem.problem_name,
                problemDescription: new_problem.problem_description,
                updatedAt: new Date(new_problem.updated_at),
                deletedAt: new Date(new_problem.deleted_at),
                createdAt: new Date(new_problem.created_at),
                isEditable: new_problem.is_editable,
                month: new_problem.month
            };
            onSuccess(updatedProblem);
        }
        else {
            const response = await axios.post('/api/carePlan/addProblemList', {
                patientId: patientId,
                problemName: data.problemName,
                problemDescription: data.problemDescription
            });
            const new_problem = response.data.data.new_problem_list;
            const updatedProblem = {
                id: new_problem.id,
                patientId: new_problem.patient_id,
                carePlanId: new_problem.care_plan_id,
                problemName: new_problem.problem_name,
                problemDescription: new_problem.problem_description,
                updatedAt: new Date(new_problem.updated_at),
                deletedAt: new Date(new_problem.deleted_at),
                createdAt: new Date(new_problem.created_at),
                isEditable: new_problem.is_editable,
                month: new_problem.month
            };
            onSuccess(updatedProblem);
        }
        setIsSubmitting(false);
        // onRequestClose();
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between' }, id: "customized-dialog-title" },
            problemToEdit ? 'Edit Problem' : 'Add Problem',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Problem"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "problemName", presets: props.presets, category: "problem", field: "problem", placeholder: "e.g., Type 2 Diabetes Mellitus" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('problemDescription'), defaultValue: problemToEdit?.problemDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, problemToEdit ? 'Edit Problem' : 'Add Problem')))))));
};
